import { useEffect } from 'react';
import { clearChunkReloadGuard } from '../../utils/chunkReload';

/**
 * Renders nothing. Its only job is to clear the one-shot chunk-reload guard
 * once a lazily-loaded view has actually rendered.
 *
 * It has to live **inside** the `<Suspense>` boundary, because Suspense holds
 * the whole subtree until the lazy sibling resolves — so this component's
 * effect running is itself the proof that a chunk loaded successfully.
 *
 * Clearing the guard anywhere else re-arms the loop it exists to prevent:
 * clear it on mount and a chunk that keeps failing would reload, mount, clear,
 * fail, reload, forever.
 */
export default function ChunkLoadHealthy() {
  useEffect(() => {
    clearChunkReloadGuard();
  }, []);

  return null;
}
